export enum NavigationMenuConstant {
  recent = 'recent',
  favorite = 'favorite',
  design = 'design',
  order = 'order',
  invoice = 'invoice',
  account = 'account',
}
